export default __webpack_public_path__ + "app/components/modal/confirmation-modal.html";